import { connect } from 'react-redux';
import { BreadCrumbs, IBreadCrumbsProps } from '../../components/BreadCrumbs';
import { TApplicationState } from '../../types/redux';
import { getBreadCrumbs } from '../../selectors/newbuilding/getBreadCrumbs';

// oxlint-disable-next-line typescript/no-explicit-any
type TBreadCrumbsStateProps = Pick<IBreadCrumbsProps, 'breadCrumbs'>;

export function mapStateToProps(state: TApplicationState): TBreadCrumbsStateProps {
  return {
    breadCrumbs: getBreadCrumbs(state),
  };
}

export const BreadCrumbsContainer = connect(mapStateToProps)(BreadCrumbs);
